import React, {SVGProps, useId} from 'react';

import {COLORS} from '@/styles/colors';

export const CheckIcon = (props: SVGProps<SVGSVGElement>) => {
  const maskId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '1em'}
      height={props.height ?? '1em'}
      fill="none"
      viewBox="0 0 24 24"
      {...props}>
      <mask
        id={maskId}
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}>
        <path
          fill={COLORS.BACKGROUND_ON_SECONDARY_CONTAINER}
          d="M0 0h24v24H0z"
        />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          fill={props.color ?? COLORS.ON_SURFACE_1}
          d="m9.55 14.947 8.368-8.368c.227-.228.495-.342.801-.342.307 0 .574.114.802.342.228.228.342.498.342.811 0 .313-.114.584-.342.812l-9.17 9.188a1.098 1.098 0 0 1-.8.341c-.307 0-.575-.114-.803-.341L4.46 13.102a1.076 1.076 0 0 1-.332-.812c.007-.313.124-.583.351-.81.228-.229.499-.343.812-.343.313 0 .583.114.81.342l3.45 3.468Z"
        />
      </g>
    </svg>
  );
};
